import React, { useEffect, useState } from "react";
import { collection, getDocs, updateDoc, deleteDoc, doc } from "firebase/firestore";
import { db } from "./firebase";
import "./styles.css";

function AdminPanel() {
  const [entries, setEntries] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [editing, setEditing] = useState({});
  const [filter, setFilter] = useState("all");
  const LABELS = {
    uin: "UIN",
    sweEmail: "Societal SWE Email",
    tamuEmail: "TAMU Email"
  }

  useEffect(() => {
    const fetchData = async () => {
      const snapshot = await getDocs(collection(db, "internships"));
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      setEntries(data);
    };
    fetchData();
  }, []);

  const toggleExpand = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this entry?")) {
      await deleteDoc(doc(db, "internships", id));
      setEntries((prev) => prev.filter((entry) => entry.id !== id));
    }
  };

  const toggleApproval = async (entry) => {
    const updated = { ...entry, approved: !entry.approved };
    await updateDoc(doc(db, "internships", entry.id), updated);
    setEntries((prev) =>
      prev.map((e) => (e.id === entry.id ? updated : e))
    );
  };

  const handleEditToggle = (id) => {
    setEditing((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleFieldChange = (id, field, value) => {
    setEntries((prev) =>
      prev.map((entry) =>
        entry.id === id ? { ...entry, [field]: value } : entry
      )
    );
  };

  const saveChanges = async (id) => {
    const entry = entries.find((e) => e.id === id);
    await updateDoc(doc(db, "internships", id), entry);
    setEditing((prev) => ({ ...prev, [id]: false }));
    alert("Changes saved!");
  };

  const filterEntries = () => {
    const year = new Date().getFullYear();
    return entries.filter((entry) => {
      if (filter === "approval") return !entry.approved;
      if (filter === "removal") {
        const removalYear = parseInt(entry.contactRemovalYear);
        return removalYear && removalYear <= year;
      }
      return true;
    });
  };

  const filtered = filterEntries();

  return (
    <div className="intern-list-container">
      <h2>Admin Panel</h2>

      <div className="filter-row">
        <select value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="all">All Entries</option>
          <option value="approval">Needs Approval</option>
          <option value="removal">Contact Removal Needed</option>
        </select>
      </div>

      <div className="table-header">
        <span>Name</span>
        <span>Major</span>
        <span>Company</span>
        <span>Approval</span>
        <span>Actions</span>
      </div>

      {filtered.length === 0 ? (
        <p style={{ marginTop: "1rem" }}>No entries match your filters.</p>
      ) : (
        filtered.map((entry) => (
          <div key={entry.id} className="table-row">
            <span>{entry.name}</span>
            <span>{entry.major}</span>
            <span>{entry.company}</span>
            <span>
              <button onClick={() => toggleApproval(entry)}>
                {entry.approved ? "✅" : "❌"}
              </button>
            </span>
            <span>
              <button onClick={() => toggleExpand(entry.id)}>
                {expanded[entry.id] ? "Hide" : "More"}
              </button>
              <button onClick={() => handleDelete(entry.id)} style={{ marginLeft: "0.5rem" }}>
                Delete
              </button>
            </span>

            {expanded[entry.id] && (
              <div className="more-info">
                {[
                  "role",
                  "location",
                  "session",
                  "applicationDate",
                  "offerDate",
                  "contact",
                  "description",
                  "source",
                  "memberID",
                  "uin",
                  "sweEmail",
                  "tamuEmail",
                  "contactRemovalYear"
                ].map((field) => (
                  <p key={field}>
                    <strong>{LABELS[field] || (field.charAt(0).toUpperCase() + field.slice(1))}:</strong>{" "}
                    {editing[entry.id] ? (
                      <input
                        value={entry[field] || ""}
                        onChange={(e) =>
                          handleFieldChange(entry.id, field, e.target.value)
                        }
                      />
                    ) : (
                      entry[field] || "—"
                    )}
                  </p>
                ))}
                {editing[entry.id] ? (
                  <button onClick={() => saveChanges(entry.id)}>Save</button>
                ) : (
                  <button onClick={() => handleEditToggle(entry.id)}>Edit</button>
                )}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}

export default AdminPanel;

